import { whenHasValue } from 'src/shared/NullUtil';
import { VimeoParser } from 'src/shared/VimeoParser/VimeoParser';

export class VimeoPlayerParser extends VimeoParser {

    constructor(nodeName: string, videoAttributeSourceName: string) {
        super(nodeName, videoAttributeSourceName);
    }

    public extract(url: string): string | null {
        return this.extractPlayer(url);
    }

    /**
     * Extracts the video id from the given url to vimeo player
     * @param url       The url to extract the video id from
     * @return          The video id if it can be extracted, otherwise `null`
     */
    private extractPlayer(url: string): string | null {
        // accepted is url starting with 'https://player.vimeo' then top level domain + '/video/'
        // finally video id represented by number and optionally arguments
        // 'https://player.vimeo.com/video/12345678'
        return whenHasValue(url.match(/^(?:https:\/\/player\.vimeo)\.[a-zA-Z]+\/video\/(\d+)(.+)?/), (match) => {
            return this.parseVideoId(match);
        });
    }
}
